var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddAPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8583 22398)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8583 -22398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,0c45.523,0,50,4.477,50,50s-4.477,50-50,50S0,95.523,0,50,4.477,0,50,0Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,0c45.523,0,50,4.477,50,50s-4.477,50-50,50S0,95.523,0,50,4.477,0,50,0Z",
    transform: "translate(0 0)",
    fill: "#91b850",
    opacity: 0.73
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.468,4.968V1.5H5.78V4.968H9.248V7.28H5.78v3.468H3.468V7.28H0V4.968ZM6.936,11.9V8.436H10.4V4.968H18.5L20.613,7.28h3.665a2.319,2.319,0,0,1,2.312,2.312V23.465a2.319,2.319,0,0,1-2.312,2.312H5.78a2.319,2.319,0,0,1-2.312-2.312V11.9Zm8.092,10.4a5.78,5.78,0,1,0-5.78-5.78A5.782,5.782,0,0,0,15.029,22.309Zm-3.7-5.78a3.7,3.7,0,1,0,3.7-3.7A3.7,3.7,0,0,0,11.329,16.529Z",
    transform: "translate(-8546.006 -22361.35)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAPhoto);
export default __webpack_public_path__ + "static/media/Add-a-photo.145b8ebbe6aa71ee7b4eca0d564b6465.svg";
export { ForwardRef as ReactComponent };